import React, { useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TableSortLabel from "@mui/material/TableSortLabel";
import Typography from "@mui/material/Typography";
import Pagination from "@mui/material/Pagination";
import { PaginationBox } from "../ManageUsers/ManageUsersStyled";
import { Constants } from "../Content";
import { Link } from "@mui/material";
export const ManageUserTable = ({
  customActions,
  headers,
  rows,
  pageNumber,
  handleChangePage,
  handlePrivilege,
  rowsPerPage,
  isRoleType,
}) => {
  const [order, setOrder] = React.useState(Constants.ASENDING);
  const [orderBy, setOrderBy] = useState("");

  console.log(headers, "hgdhgsa");
  console.log(rows, "rowwwww");

  const createSortHandler = (property) => (event) => {
    setOrder(
      order === Constants.ASENDING ? Constants.DECENDING : Constants.ASENDING
    );
    setOrderBy(property);
  };
  function descendingComparator(a, b, orderBy) {
    if (!a[orderBy]) return 1; 
    if (!b[orderBy]) return -1;
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  function getComparator(order, orderBy) {
    return order === Constants.DECENDING
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) {
        return order;
      }
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  return (
    <div>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 400 }} aria-label="customized table">
          <TableHead>
            <TableRow>
              {!isRoleType && <TableCell>{Constants.ACTION}</TableCell>}

              {headers?.map((header) => (
                <TableCell>
                  {header.label}
                  {header.isSortable && (
                    <TableSortLabel
                      active={orderBy === header.id}
                      direction={
                        orderBy === header.id ? order : Constants.DECENDING
                      }
                      onClick={createSortHandler(header.id)}
                    ></TableSortLabel>
                  )}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.length > 0 ? (
              (rowsPerPage > 0
                ? stableSort(rows, getComparator(order, orderBy)).slice(
                    (Number(pageNumber) - 1) * rowsPerPage,
                    (Number(pageNumber) - 1) * rowsPerPage + rowsPerPage
                  )
                : rows
              ).map((row, index) => (
                <TableRow key={index}>
                  {!isRoleType && (
                    <TableCell size="small">
                      {customActions && customActions(row)}
                    </TableCell>
                  )}
                  {headers?.map((header) => (
                    <TableCell size="small" style={{ wordBreak: "break-all" }}>
                      {header.id === "actionName" ? (
                        <Link className="link" onClick={handlePrivilege(row)}>
                          {Constants.VIEW}
                        </Link>
                      ) : (
                        row[header.id]
                      )}
                    </TableCell>
                  ))}
                </TableRow>
              ))
            ) : (
              <TableRow>
                {rows.length === 0 && (
                  <TableCell
                    colSpan={headers.length + 1}
                    align="center"
                    className="noquotecell"
                  >
                    <p className="noquotetext"> {Constants.NODATA}</p>
                  </TableCell>
                )}
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <PaginationBox>
        <Typography variant="h6">
          {rows.length}
          <span>Total Results</span>
        </Typography>
        {!isRoleType && (
          <Pagination
            count={Math.ceil(rows.length / rowsPerPage)}
            page={pageNumber}
            onChange={handleChangePage}
          />
        )}
      </PaginationBox>
    </div>
  );
};

export default ManageUserTable;
